import React from 'react';

import { Formik } from 'formik';
import { useSnackbar } from 'notistack';
import * as Yup from 'yup';

import { CONFIGS } from '../../utilities/Configs';
import { ConstructFetchBody, UrlQueryParam } from '../../utilities/Helpers';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@material-ui/core';

type Props = {
	onAdd: () => void,
	onClose: () => void
};

export const BrandAdd = (props: Props) => {
	const { enqueueSnackbar } = useSnackbar();

	const handleSubmit = (_values, _formikBag) => {
		fetch(CONFIGS.API.ENDPOINT, ConstructFetchBody(CONFIGS.API.METHODS.BRAND_UPSERT, [UrlQueryParam('token'),  _values.name, -1])).then(
			(_response) => _response.json()
		).then(
			(_response) => {
				if (_response?.error !== undefined) {
					enqueueSnackbar(_response?.error.message, { variant: 'error' });
				}
				else {
					props.onAdd();
					props.onClose();

					enqueueSnackbar('Brand added!', { variant: 'success' });
				}
			}
		).catch(
			() => enqueueSnackbar('An unexpected error has occurred. Please try again later. If problem persists, please contact support.', { variant: 'error' })
		).finally(
			() => _formikBag.setSubmitting(false)
		);
	};
	
	return (
		<Formik
			initialValues={{
				name: ''
			}}
			onSubmit={handleSubmit}
			validateOnBlur={false}
			validateOnChange={false}
			validationSchema={
				Yup.object().shape({
					name: Yup.string().required('Required')
				})
			}
		>
			{
				(_formik) => (
					<Dialog open maxWidth="xs" fullWidth>
						<DialogTitle className="header orange">Add Brand</DialogTitle>
						<DialogContent dividers>
							<Grid container spacing={1}>
								<Grid item xs={12}>
									<div>
										<TextField
											name="name"
											value={_formik.values.name}
											label="Name *"
											InputLabelProps={{
												shrink: true
											}}
											variant="outlined"
											margin="dense"
											fullWidth
											onChange={(_event) => _formik.setFieldValue('name', _event.target.value)}
										/>
										{
											_formik.errors.name !== undefined && (
												<p className="error">{_formik.errors.name}</p>
											)
										}
									</div>
								</Grid>
							</Grid>
						</DialogContent>
						<DialogActions>
							<Button variant="contained" color="default" disabled={_formik.isSubmitting} onClick={props.onClose}>Cancel</Button>
							<Button variant="contained" color="primary" disabled={_formik.isSubmitting} onClick={() => _formik.handleSubmit()}>Save</Button>
						</DialogActions>
					</Dialog>
				)
			}
		</Formik>
	);
};